<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{item.text}}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">{{ele}}</p>
            <div class="down-btn">立即下载</div>
          </div>
          <div>
            <el-image style="width: 100%; height: 100%" fit='contain' :src="item.rightImage"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 会员登录 start -->
    <div class="user-login">
      <p class="login-p">会员登录</p>
      <el-row type="flex" justify="center">
        <el-col :span='6'>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="账号:">
              <el-input v-model="form.user"></el-input>
            </el-form-item>
            <el-form-item label="密码:">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label-width="80px">
              <el-button type="primary" @click="login">登录</el-button>
              <el-button @click="toUserSet">注册</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <!-- 会员登录 end -->

  </div>
</template>

<script>
import banner1 from '@/assets/imgs/banner-1.png';
import banner2 from '@/assets/imgs/banner-2.png';
import banner1r from '@/assets/imgs/banner-1-right.png';
import banner2r from '@/assets/imgs/banner-2-right.png';
export default {
  data() {
    return {
      form: {
        user: '',
        password: ''
      },
      carouselItem: [
        {
          bgcIma: banner1,
          rightImage: banner1r,
          text: '企业OA系统软件',
          list: [
            '●在现办公', '●即时下载', '●会员优惠价：6000元'
          ]
        },
        {
          bgcIma: banner2,
          rightImage: banner2r,
          text: '在线商城软件下载',
          list: [
            '●企业独立运营商城', '●助力企业快速进入移动电商时代', '●会员优惠价：1800元（不含服务器）'
          ]
        }
      ]
    }
  },
  methods: {
    login() {
      setTimeout(() => {
        this.$alert('登录失败', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: '登录失败'
            });
          }
        });

      }, 1500);
    },
    toUserSet() {
      this.$router.push({
        path: '/userset'
      })
    }
  }
}
</script>


<style scoped>
.carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
 }
 .info-box {
   width: 60%;
   height: 70%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   display: flex;
 }
 .info-box div {
   flex: 1;
   color: #fff;
   font-size: 18px;
 }
 .title {
   font-size: 46px;
   padding: 20px 0;
 }
 .info-tip {
   padding: 5px 0;
 }
 .down-btn {
   width: 120px;
   text-align: center;
   padding: 10px 20px;
   border: 1px solid #fff;
   cursor: pointer;
   margin-top: 40px;
 }

 .user-login {
   padding: 10px 300px;
 }

 .login-p {
   padding-bottom: 10px;
   color: #009fe9;
   border-bottom: 1px solid #b3b3b3;
   margin-bottom: 5px;
 }
</style>



// WEBPACK FOOTER //
// src/components/userlogin.vue